import React, { useMemo } from "react";

import { ColumnsType } from "antd/es/table";
import Tag from "antd/es/tag";
import { useIntl } from "react-intl";

import { Company, Deal, Person } from "@mapmycustomers/shared/types/entity";
import { UserRef } from "@mapmycustomers/shared/types/User";
import { Avatar } from "@mapmycustomers/ui";

import DealName from "@app/component/deal/DealName";
import localSettings from "@app/config/LocalSettings";
import { formatRawDate } from "@app/util/formatters";

import styles from "../DealListModal.module.scss";

const useRottingDealListColumns = (
  onCompanyPreview: (companyId: Company["id"]) => void,
  onPersonPreview: (personId: Person["id"]) => void
): ColumnsType<Deal> => {
  const intl = useIntl();
  return useMemo(
    () => [
      {
        dataIndex: "name",
        render: (name, deal) => (
          <DealName deal={deal} onCompanyClick={onCompanyPreview} onPersonClick={onPersonPreview} />
        ),
        title: intl.formatMessage({
          id: "rottingDealListModal.column.name",
          defaultMessage: "Deal Name",
        }),
      },
      {
        dataIndex: "amount",
        render: (amount: number) =>
          intl.formatNumber(amount, {
            currency: localSettings.getCurrencyCode(),
            minimumFractionDigits: 0,
            style: "currency",
          }),
        title: intl.formatMessage({
          id: "rottingDealListModal.column.amount",
          defaultMessage: "Amount",
        }),
      },
      {
        dataIndex: "rottingDaysOut",
        render: (rottingDaysOut: number) => {
          return <div className={styles.rottingDaysOut}>{rottingDaysOut}</div>;
        },
        title: intl.formatMessage({
          id: "rottingDealListModal.column.rottingDaysOut",
          defaultMessage: "Days in stage",
        }),
      },
      {
        dataIndex: "closingDate",
        render: (closingDate: string) => <Tag>{formatRawDate(closingDate, "PPP")}</Tag>,
        title: intl.formatMessage({
          id: "rottingDealListModal.column.ClosedDate",
          defaultMessage: "Close Date",
        }),
      },
      {
        dataIndex: "user",
        render: (user: UserRef) => <Avatar user={user} />,
        title: intl.formatMessage({
          id: "rottingDealListModal.column.owner",
          defaultMessage: "Owner",
        }),
      },
    ],
    [intl, onCompanyPreview, onPersonPreview]
  );
};

export default useRottingDealListColumns;
